import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Message } from '../../models/message';
import { AppSettings } from '../../../../../utils/app-settings';

@Injectable()
export class MessagesService {

  constructor(private http: HttpClient) { }

  getMessages(filterId: number, folder: string): Observable<Array<Message>> {
    return this.http.get<Array<Message>>(AppSettings.apiUrl + "messages?folder=" + folder + "&filterId=" + filterId);
  }

  getMessageById(id: number, markread: boolean, folder: string): Observable<Message> {
    return this.http.get<Message>(`${AppSettings.apiUrl}messages/${id}?markread=${markread}&folder=${folder}`);
  }

  sendMessage(subject: string, content: string, toPersons: Array<string>, toPersonGroups: Array<string>, toStudentGroups: Array<string>, file_id?: number) {
    return this.http.post(AppSettings.apiUrl + "messages",
      {
        "subject": subject,
        "content": content,
        "to_persons": toPersons,
        "to_person_groups": toPersonGroups,
        "to_student_groups": toStudentGroups,
        "file_id": file_id
      });
  }

}
